import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_FAQS, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_FAQ,
  UPDATE_FAQ,
  DELETE_FAQ,
  GET_FAQ_PROFILE
 } from "./actionTypes";
import {
  getFaqsSuccess,
  getFaqsFail,
  addFaqSuccess,
  addFaqFail,
  updateFaqSuccess,
  updateFaqFail,
  deleteFaqSuccess,
  deleteFaqFail,
  getFaqProfileSuccess,
  getFaqProfileFail
  // getFaqProfileSuccess,
  // getFaqProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getFaqs,
  // getFaqProfile,
  addNewFaq,
  updateFaq,
  deleteFaq,
  // getFaqProfile
} from "../../helpers/backend_helper";
import { setDataEdit, showPopup } from "../popup/actions";

function* fetchFaqs({payload}) {
  try {
    const response = yield call(getFaqs,payload);
    console.log({response})
    yield put(getFaqsSuccess(response));
  } catch (error) {
    yield put(getFaqsFail(error));
  }
}

// function* fetchFaqProfile({payload}) {
//   try {
//     const response = yield call(getFaqProfile,payload);
//     yield put(getFaqProfileSuccess(response));
//     yield put(setDataEdit(response.coveredLocation))
//   } catch (error) {
//     yield put(getFaqProfileFail(error));
//   }
// }

function* onUpdateFaq({ payload: { faq } }) {
  try {
   let response = yield call(updateFaq, faq);
    yield put(updateFaqSuccess(faq));
    yield put(showPopup({title:response.message,success:true}));
  } catch (error) {
    yield put(updateFaqFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onDeleteFaq({ payload: faq }) {
  try {
     let response = yield call(deleteFaq, faq);
    yield put(deleteFaqSuccess(faq));
    yield put(showPopup({title:response.message,success:true}));
  } catch (error) {
    yield put(deleteFaqFail(error));
    yield put(showPopup({ title: error.response.data.message, error: true }));
    

  }
}

function* onAddNewFaq({ payload: { user }}) {
  try {
    let response = yield call(addNewFaq, user)
    yield put(addFaqSuccess(user))
    yield put(showPopup({title:response.message,success:true}));
  } catch (error) {
    yield put(addFaqFail(error))
      // yield put(showPopup({title:error.response.data.message,error:true}));

  }
}


// function* fetchFaqProfile() {
//   try {
//     const response = yield call(getFaqProfile);
//     yield put(getFaqProfileSuccess(response));
//   } catch (error) {
//     yield put(getFaqProfileFail(error));
//   }
// }

function* faqsSaga() {
  yield takeEvery(GET_FAQS, fetchFaqs);
  // yield takeEvery(GET_FAQ_PROFILE, fetchFaqProfile);
  yield takeEvery(ADD_NEW_FAQ, onAddNewFaq);
  yield takeEvery(UPDATE_FAQ, onUpdateFaq);
  yield takeEvery(DELETE_FAQ, onDeleteFaq);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchFaqProfile);
}

export default faqsSaga;
